// Shared constants and types to prevent circular dependencies

// Sheet name mappings
export const SHEET_MAPPINGS = {
  'dashboard': 'Dashboard Stats',
  'lead-requests': 'Lead Requests',
  'pipeline-leads': 'Pipeline',
  'call-leads': 'Leads',
  'whatsapp-leads': 'Leads',
  'email-leads': 'Leads',
  'pre-qualified': 'Pre-Qualified Leads',
  'qualified': 'Qualified Leads',
  'meetings': 'Meetings'
};

// Pipeline stages
export const PIPELINE_STAGES = [
  { id: 'demo_tbr', name: 'Demo TBR', color: 'bg-yellow-100 text-yellow-800 border-yellow-200', description: 'Demo needs rescheduling' },
  { id: 'demo_booked', name: 'Demo Booked', color: 'bg-blue-100 text-blue-800 border-blue-200', description: 'Meeting scheduled with prospect' },
  { id: 'proposal_sent', name: 'Proposal Sent', color: 'bg-cyan-100 text-cyan-800 border-cyan-200', description: 'Formal offer submitted' },
  { id: 'follow_up', name: 'Follow Up', color: 'bg-purple-100 text-purple-800 border-purple-200', description: 'Following up with prospect' },
  { id: 'closed_won', name: 'Closed WON', color: 'bg-green-100 text-green-800 border-green-200', description: 'Deal successfully secured' },
  { id: 'closed_lost', name: 'Closed Lost', color: 'bg-red-100 text-red-800 border-red-200', description: 'Opportunity not pursued' }
];

// Pipeline stage names for updates
export const PIPELINE_STAGE_NAMES = [
  'Demo TBR',
  'Demo Booked',
  'Proposal Sent',
  'Follow Up',
  'Closed WON',
  'Closed Lost'
];

// Lead generation form constants
export const QUANTITY_OPTIONS = [25, 50, 100, 200];

export const CAMPAIGNS = [
  'Call Campaign',
  'WhatsApp Campaign',
  'Email Campaign',
  'LinkedIn Campaign',
  'Omni-Channel Campaign'
];

export const MAKE_WEBHOOK_URL = 'https://hook.test.com';

// Default stats structure
export const DEFAULT_STATS = {
  totalLeadsRequested: 0,
  totalInProgress: 0,
  totalDelivered: 0,
  preQualified: 0,
  qualified: 0,
  called: 0,
  whatsapped: 0,
  emailed: 0,
  conversionRate: 0
}